import { platforms, articles } from '@/mocks/data';
import { Link } from 'react-router-dom';

export default function PlatformBanner() {
  return (
    <section className="py-12 px-4 md:px-6 bg-gradient-to-r from-primary-500 via-primary-600 to-accent-600">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-white">
            合作视频平台
          </h2>
          <p className="text-sm text-white/70 mt-2">汇聚六大平台优质内容，一站畅享高清影视</p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {platforms.map((platform) => (
            <div
              key={platform.slug}
              className="px-5 py-3 bg-white/15 backdrop-blur-sm rounded-xl border border-white/20 text-white cursor-pointer hover:bg-white/25 transition-all duration-300"
            >
              <span className="text-sm md:text-base font-semibold whitespace-nowrap">{platform.name}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {articles.slice(0, 3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="block bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/15 hover:bg-white/20 transition-all duration-300 cursor-pointer"
            >
              <span className="text-xs px-2 py-0.5 bg-white/20 text-white rounded-md">{article.category}</span>
              <h3 className="text-white font-semibold text-sm mt-2 line-clamp-2">{article.title}</h3>
              <p className="text-white/60 text-xs mt-1.5 line-clamp-2">{article.summary}</p>
              <div className="flex items-center justify-between mt-3">
                <span className="text-xs text-white/40">{article.date}</span>
                <span className="text-xs text-accent-300 flex items-center gap-1">
                  阅读更多 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}